import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    leftText: {
      marginTop: '10px',
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 14,
      lineHeight: '17px',
      color: '#2C2D3E',
      marginLeft: '38px',
    },
    rightText: {
      marginTop: '10px',
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '16px',
      color: '#2C2D3E',
      verticalAlign: 'center',
      marginLeft: '38px',
    },
    line: {
      position: 'relative',
      width: '544px',
      size: '0px',
      color: '#2c2d3e',
      opacity: 0.3,
      display: 'inline-block',
      align: 'center',
      marginBottom: '8px',
    },
    textIcon: {
      marginTop: '0px',
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '16px',
      color: '#2C2D3E',
      verticalAlign: 'center',
      marginLeft: '38px',
    },
    checkIcon: {
      position: 'relative',
      top: '5px',
      left: '-30px',
      color: '#347F42'
    }
  }),
);
